import React, { useEffect, useState } from "react";
import SideBar from "../Navbar/Sidebar";

import Modal from "react-modal";
import {
  allLeadsList,
  assignedList,
  companyEmailApi,
  createProposalApi,
  emailsLists,
  propsalAddressApi,
} from "../Apis/apis";
import { useParams } from "react-router-dom";
const initalState = {
  address: "",
  date: "",
  open_till: "",
  discount: "",
  city: "",
  email: "",
  state: "",
  country: "",
  phonenumber: "",
  pan: "",
  gistin: "",
  zip: "",
};
const upperFields = {
  subject: "",
  status: "",
  media_path_slug: "",
  related: "",
  name: "",
};
const itemdata = {
  deatils: "",
  hscsac: "",
  sqlft: "",
  qlt: "",
  rate: "",
  tax: "",
  ammount: "",
};
const Proposals = () => {
  const { id } = useParams();
  const [model, setModel] = useState(false);
  const [editmodel, setEditModel] = useState(false);
  const [AssignLead, setAssignLead] = useState([]);
  const [leads, setLeads] = useState([]);
  const [alladdress, setAddress] = useState([]);
  const [comapnydata, setComapnyData] = useState(initalState);
  const [items, setItems] = useState(itemdata);
  const [upperData, setupperData] = useState(upperFields);
  const [arrays, setarrays] = useState([]);
  const { email, address, country, phonenumber, pan, gistin, zip } =
    comapnydata;
  const { subject, status, media_path_slug, related, name } = upperData;
  const { deatils, hscsac, sqlft, qlt, rate, tax, ammount } = items;



  const headers = [
    { key: "Deatils", label: "Deatils" },
    { key: "HSC/SAC", label: "HSC/SAC" },
    { key: "Area(sq.ft)", label: "Area(sq.ft)" },
    { key: "Qlt", label: "Qlt" },
    { key: "Rate", label: "Rate" },
    { key: "Tax", label: "Tax" },
    { key: "Ammount", label: "Ammount" },
    { key: "edit", label: "Update" },
  ];
  const assignLeads = async () => {
    const data = await assignedList(related);
    setAssignLead(data);
  };
  const allLeads = async () => {
    const data = await emailsLists(related);
    setLeads(data);
  };

  const createProposal = async () => {

    if (arrays.length == 0) {
      return alert("Create Task First");
    } else {
      const path = "/webleads";
      const data = await createProposalApi(
        path,
        id,
        upperData,
        comapnydata,
        arrays
      );
    }
  };

  const getAlladdress = async (email) => {
    const data = await propsalAddressApi(email, related);
    setAddress(data);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setComapnyData({ ...comapnydata, [name]: value });
  };
  const ItemChange = async (e) => {
    const { name, value } = e.target;
    setItems({ ...items, [name]: value });
  };

  const arrayChange = async (e) => {
    const { name, value } = e.target;
    setItems({ ...items, [name]: value });
  };
  const UpperChange = async (e) => {
    const { name, value } = e.target;
    setupperData({ ...upperData, [name]: value });
  };

  useEffect(() => {
    setComapnyData({ ...alladdress[0] });
  }, [alladdress]);
  useEffect(() => {
    setItems({ ...arrays[0] });
  }, [arrays]);

  const saveItems = async (e) => {
    e.preventDefault();
    setarrays((itemvalues) => [...itemvalues, items]);
    setModel(false);
  };

  const [index, setindex] = useState();
  const [indexdata, setindexData] = useState();

  const Editrow = (e, id) => {
    setindex(id)
    setindexData(e)
    setEditModel(true)

    setItems(
      {
        deatils: e.deatils,
        hscsac: e.hscsac,
        sqlft: e.sqlft,
        qlt: e.qlt,
        rate: e.rate,
        tax: e.tax,
        ammount: e.ammount,
      })


  }




  const Updaterow = () => {
    const data = [...arrays]
    data[index] = items
    setarrays(data)
    setEditModel(false)
  }


  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="row container-pages  dash-chartss ">
        <div className="col-4">
          <label for="subject">Subject</label>
          <input
            id="subject"
            type="text"
            value={subject}
            name="subject"
            onChange={UpperChange}
            className="form-control ms-0"
            required
          />

          <label for="name">To</label>
          <input
            id="name"
            type="text"
            name="name"
            value={name}
            onChange={UpperChange}
            className=" form-control ms-0" required
          />

          <label for="phonenumber">Phone</label>
          <input
            className=" form-control m-2 ms-0"
            id="phonenumber"
            type="number"
            name="phonenumber"
            value={phonenumber}
            onChange={handleChange} required
          />
          <label for="country" className="">
            Country
          </label>
          <input
            className=" form-control ms-0"
            id="country"
            name="country"
            value={country}
            type="text"
            onChange={handleChange} required
          />
          <label for="pan" className="">
            PAN
          </label>
          <input
            className="m-2 mt-1 form-control ms-0"
            id="pan"
            type="text"
            name="pan"
            value={pan}
            onChange={handleChange} required
          />
        </div>
        <div className="col-4">
          <label for="Email" className="mt-1">
            Email:
          </label>
          <input
            className=" form-control ms-0 m-2 me-0"
            id="Email"
            type="email"
            name="email"
            value={email}
            onChange={handleChange} required
          />
          <label for="address" className="mt-1">
            Address
          </label>
          <input
            id="address"
            name="address"
            value={address}
            type="text"
            onChange={handleChange}
            className=" form-control ms-0 me-0" required
          />
          <label for="zip" className="m-1 ">
            Zip Code
          </label>
          <input
            className=" form-control ms-0 me-0"
            id="zip"
            type="number"
            name="zip"
            value={zip}
            onChange={handleChange} required
          />

          {/* <label for="pan" className="mt-2 mb-0">
            PAN
          </label>
          <input
            className=" form-control ms-0"
            id="pan"
            type="text"
            name="pan"
            value={pan}
            onChange={handleChange}
          /> */}

          <label for="gistin" className="mt-3">
            GSTIN
          </label>
          <input
            className=" form-control mt-1 ms-0"
            id="gistin"
            type="text"
            name="gistin"
            value={gistin}
            onChange={handleChange} required
          />
        </div>

        <div className="col-4">
          <label for="status">Status</label>

          <select
            id="status"
            value={status}
            name="status"
            className="custom-select custom-selectt  m-2 ms-0 w-100"
            onChange={UpperChange}
            required
          >
            <option value="1" defaultValue="Draft" selected>
              Draft
            </option>
            <option value="2">Sent</option>
            <option value="3">Declined</option>
            <option value="4">Revised</option>
            <option value="5">Accepted</option>
          </select>

          <label for="media_path_slug" className="mt-1">
            {" "}
            Assigned
          </label>
          <select
            id="media_path_slug"
            value={media_path_slug}
            className="custom-select custom-selectt m-2 ms-0 w-100"
            name="media_path_slug"
            onClick={() => assignLeads()}
            onChange={UpperChange}
            required
          >
            <option disabled={true} selected>
              Assigned
            </option>
            {AssignLead.map((el) => (
              <option value={el.media_path_slug}>{el.media_path_slug}</option>
            ))}
          </select>

          <label for="related" className="mt-2">Related</label>
          <select
            id="related"
            className="custom-select custom-selectt mt-1 ms-0 w-100"
            value={related}
            name="related"
            onChange={UpperChange}
            onClick={allLeads}
            required
          >
            <option selected></option>
            <option onClick={allLeads} value="lead">
              Lead
            </option>
            <option onClick={allLeads} value="Customer">
              Customer
            </option>
          </select>

          <label for="lead" className="mt-2">
            {" "}
            {related === "lead" ? "Lead:" : "Customer:"}
          </label>
          <select
            className="custom-select custom-selectt m-2 ms-0 w-100"
            id="lead"
            name="lead"
            onChange={(e) => getAlladdress(e.target.value)}
            required
          >
            {leads.map((el) => (
              <option value={el.email}>{el.email}</option>
            ))}
          </select>

          <button className=" w-100 add-itm" onClick={(e) => setModel(true)}>
            Add Item
          </button>


        </div>


        <div className="row">

          <table className="table table-boarder table-hover table-striped  table-sm">
            <thead className="thead-dark ">
              <tr className="text-center">
                {headers.map((row) => (
                  <td key={row.key}>{row.label}</td>
                ))}
              </tr>
            </thead>
            <tbody>

              {arrays.map((el, id) => (
                <tr key={id}>
                  <th className="text-center">{el.deatils}</th>
                  <th className="text-center">{el.hscsac}</th>
                  <th className="text-center">{el.sqlft}</th>
                  <th className="text-center"> {el.rate}</th>
                  <th className="text-center"> {el.qlt}</th>
                  <th className="text-center"> {el.tax}</th>
                  <th className="text-center"> {el.ammount}</th>
                  <th className="text-center">
                    <button className="show-btn border-0" onClick={(e) => Editrow(el, id)}>Edit</button>{" "}
                  </th>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
        <div className="text-center">

          <button onClick={() => createProposal()} className="db-btn border-0 w-50 ">
            Save
          </button>
        </div>
      </div>

      {/* create row data */}
      <Modal isOpen={model} className=".form_modal">
        <button className="border-0  float-right text-danger" onClick={(e) => setModel(false)}>
          X
        </button>


        <form onSubmit={(e) => saveItems(e)}>
          <div className="row p-2">
            <div className="col-6">
              <label for="hscsac">HSC/SAC</label>
              <input type="number" name="hscsac" onChange={ItemChange} required className=" form-control ms-0" />

              <label for="area">Area(sq.ft)</label>
              <input type="text" name="sqlft" onChange={ItemChange} required className=" form-control ms-0" />
              <label for="qlt">Qlt</label>
              <input type="number" name="qlt" onChange={ItemChange} required className=" form-control ms-0" />
            </div>
            <div className="col-6">
              <label for="rate">Rate</label>
              <input type="number" name="rate" onChange={ItemChange} required className=" form-control ms-0" />
              <label for="tax">GST (18%)</label>
              <input type="number" name="tax" onChange={ItemChange} required className=" form-control ms-0" />
              <label for="ammount">Total Ammount</label>
              <input type="number" name="ammount" onChange={ItemChange} required className=" form-control ms-0" />

            </div>
            <div className="col-12">
              <label for="details">Deatails</label>
              <textarea type="text" name="deatils" onChange={ItemChange} className=" form-control "> </textarea>

              <div className="d-flex justify-content-center">
                <input type="submit" value="Save" className="m-2 w-50" />
              </div>


            </div>

          </div>
        </form>


      </Modal>



      {/* update row data  */}
      <Modal isOpen={editmodel} className=".form_modal">
        <button className="border-0  float-right text-danger" onClick={(e) => setEditModel(false)}>
          X
        </button>
        <form onSubmit={(e) => Updaterow(e)}>
          <div className="row p-2">

            <div className="col-6">
              <label for="hscsac">HSC/SAC</label>
              <input type="number" name="hscsac" onChange={ItemChange} value={hscsac} required className=" form-control ms-0" />

              <label for="area">Area(sq.ft)</label>
              <input type="text" name="sqlft" onChange={ItemChange} value={sqlft} required className=" form-control ms-0" />
              <label for="qlt">Qlt</label>
              <input type="number" name="qlt" onChange={ItemChange} value={qlt} required className=" form-control ms-0" />
            </div>
            <div className="col-6">
              <label for="rate">Rate</label>
              <input type="number" name="rate" onChange={ItemChange} value={rate} required className=" form-control ms-0" />
              <label for="tax">GST (18%)</label>
              <input type="number" name="tax" onChange={ItemChange} value={tax} required className=" form-control ms-0" />
              <label for="ammount">Total Ammount</label>
              <input type="number" name="ammount" onChange={ItemChange} required className=" form-control ms-0" />

            </div>
            <div className="col-12">
              <label for="details">Deatails</label>
              <textarea type="text" name="deatils" onChange={ItemChange} value={deatils} className=" form-control "> </textarea>

              <div className="d-flex justify-content-center">
                <input type="submit" value="Save" className="m-2 w-50" />
              </div>


            </div>

          </div>
        </form>


      </Modal>

    </div>
  );
};

export default Proposals;
